import { OtpRequest, OtpResponse } from './models';
import { createMutation } from '../../libs';

const url = 'auth/';

export const useSendOtp = createMutation<OtpResponse, OtpRequest>({
  method: 'post',
  url: `${url}send-otp`,
});

export const useVerifyOtp = createMutation<OtpResponse, OtpRequest>({
  method: 'post',
  url: `${url}verify-otp`,
});
